import type { PropsWithChildren } from "react";
import type { Props } from "./UserConsentsSectionContext";
import { UserConsentsSectionContext } from "./UserConsentsSectionContext";

export const UserConsentsSectionContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <UserConsentsSectionContext value={contextValue}>{children}</UserConsentsSectionContext>
);
